import { ReactNode } from 'react';
import { Skeleton, Text } from '@tectonicfi/tectonic-ui-kit';

interface CardValueProps {
  loading: boolean;
  value?: ReactNode | null;
}

function CardValue({ loading, value }: CardValueProps): JSX.Element {
  if (loading) {
    return <Skeleton data-testid="skeleton" />;
  }

  if (!value) {
    return <Text>-</Text>;
  }

  return <>{value}</>;
}

export default CardValue;
